
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    marginTop: 0,
    marginBottom: 0,
    border: 'none'
  },
});

export const RTFOND2StepdownDataTable = ({ currentRTFO, darkMode }) => {

  const units = currentRTFO?.settings?.units || 'metric';

  // STYLES
  const classes = useStyles();

  const rows = useMemo(() => {
    if (!currentRTFO?.stageData || Object.keys(currentRTFO.stageData)?.length === 0) return [];

    const rows = [];

    const stage = currentRTFO?.stageData?.[currentRTFO?.currentStageName];
    const stepdownParams = stage?.stepdownParams;

    if (!stepdownParams) return [];

    const ND2 = stepdownParams?.N * Math.pow(stepdownParams?.Dperf, 2);
    const kPerf = (0.2369 * stepdownParams?.rho / Math.pow(stepdownParams?.Cd * ND2, 2)) * 1970.031419;

    const wellName = currentRTFO?.currentStageName?.split('_')?.[1];
    const stageNumber = currentRTFO?.currentStageName?.split('_')?.[2];
    const stageClusters = currentRTFO?.perfSchedule?.wells?.[wellName]?.stages?.[stageNumber]?.clusters;
    const diameters = stageClusters && Object.keys(stageClusters)?.map(d => stageClusters[d]?.entryHoleDiameter);
    const dAvg = (diameters?.reduce((tot, curr) => tot + curr, 0) / diameters?.length) || 0.36;

    for (let d = dAvg; d <= 2; d += 0.005) {
      const N = Math.pow((16 * stepdownParams?.rho / 0.0083454 / (kPerf * 1e6) / Math.pow(Math.PI, 2)), 0.5) / stepdownParams?.Cd / Math.pow(d * 25.4 / 1000, 2);
      const perfEfficiency = N / stepdownParams?.numShots * 100;

      rows.push({
        id: d,
        DPerf: (+d * (units === 'field' ? 1 : 25.4))?.toFixed(2),
        N: +(N?.toFixed(2)),
        perfEfficiency: +(perfEfficiency?.toFixed(2))
      })
    };

    return rows;
  }, [currentRTFO?.currentStageName, currentRTFO?.perfSchedule?.wells, currentRTFO.stageData, units]);
  
  try {

    const columns = [
      {
        field: 'DPerf',
        headerName: `Dperf (${units === 'field' ? 'in' : 'mm'})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'N',
        headerName: 'Open Perfs',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'perfEfficiency',
        headerName: 'Perf Efficiency (%)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
    ];

    return (
      <Paper className={classes.root} elevation={0}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: CustomToolbar,
          }}
          sx={{
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: darkMode ? '#263238' : 'whitesmoke'
            },
            '& .super-app-theme--Current': {
              fontWeight: 'bold',
              backgroundColor: 'rgba(7, 88, 183, 0.25)' // highlight the current row
            }
          }}
          getRowClassName={(params) => {
            return (params?.row?.stageName === currentRTFO?.currentStageName) ? `super-app-theme--Current` : '';
          }}
          density="compact"
          style={{fontSize: '12px'}}
        />
      </Paper>
    );
  } catch (error) {
    return <></>
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarFilterButton style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarDensitySelector style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarExport style={{ color: darkMode && 'lightgrey' }} />
      </GridToolbarContainer>
    );
  };
};

